import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'se-fullscreen',
    templateUrl: './se-fullscreen.component.html',
    styleUrls: ['./se-fullscreen.component.css'],
    standalone: true,
    imports: [NgClass],
})
export class SeFullScreenComponent {
    // events

    @Output()
    fullscreenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    // data members

    @Input()
    enableFullscreenMode: boolean = true;

    @Input()
    changeViewIfRightSidenav?: boolean;

    private _fullscreen: boolean = false;
    get fullscreen() {
        return this._fullscreen;
    }
    @Input()
    set fullscreen(fullscreen) {
        if (this._fullscreen == fullscreen) {
            return;
        }

        this._fullscreen = fullscreen;
        this.fullscreenChange.emit(fullscreen);
    }

    // public functions

    onFullScreenToggle() {
        this.fullscreen = !this.fullscreen;
    }
}
